module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.uploadProgress) ? _c('div', {
    staticClass: "upload-progress",
    attrs: {
      "id": "upload-progress"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm._f("units")(_vm.uploadProgress.loaded)) + " / " + _vm._s(_vm._f("units")(_vm.uploadProgress.total)) + " @ " + _vm._s(Math.round(_vm.uploadProgress.speed)) + " kbps")]), _vm._v(" "), _c('div', {
    staticClass: "progress-bar",
    style: ({
      width: _vm.uploadProgress.progress + '%'
    })
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d8f2c964!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/upload-progress/UploadProgress.vue
// module id = 2108
// module chunks = 2